export default "__VITE_ASSET__gf_T5hXX__"